//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CampaignEmailVerification",
  props: {
    showNotVerifiedMssg: {
      type: Boolean,
      default: false
    }
  }
});